import React,{useEffect,useState} from 'react';
import DashboardCard from '../componenents/Cards/DashboardCard';
import { fetchArticlesService } from '../services/ArticleService';
import { fetchCategoriesService, fetchSubCategoriesService } from '../services/CategoryService';
import { fetchUsersService } from '../services/UserService';

const DashboardPage = () => {

const [articles, setArticles] = useState([]);
const [categories, setCategories] = useState([]);
const [users, setUsers] = useState([]);
const [subCategories, setSubCategories] = useState([]);

  const [loading, setLoading] = useState(true);
  const [auth, setAuth] = useState(false); // Loading state

  useEffect(() => {
    // Fetch articles from the article service
    const auth = localStorage.getItem('authToken')!=null ? true :false;
    setAuth(auth);
    console.log(auth);
    const loadArticles = async () => {
      try {
        const fetchedArticles = await fetchArticlesService(); // Fetch articles from the service
        const fetchedCategories = await fetchCategoriesService();
        const fetchedUsers = await fetchUsersService();
        const fetchedSubCategories = await fetchSubCategoriesService();
        setArticles(fetchedArticles); // Set the articles
        setCategories(fetchedCategories);
        setUsers(fetchedUsers);
        setSubCategories(fetchedSubCategories);
      } catch (error) {
        console.error('Failed to load articles', error); // Handle any errors
      } finally {
        setLoading(false); // Stop loading after fetching the articles
      }
    };

    loadArticles();
  }, []);

  return (
    <DashboardCard 
      totalArticles={articles?.length || 0}
      totalCategories={categories?.length || 0}
      totalSubCategories={subCategories?.length || 0}
      totalUsers={users?.length || 0} 
    />
  );
};

export default DashboardPage;
